<template>
  <main>
    <div class="py-4 pt-5 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection>
            <div class="text-right">
              <argon-button :to="{ name: 'Target Konsolidasi' }" isRouteLink outline><font-awesome-icon
                  icon="fa-solid fa-chevron-left" /> Kembali</argon-button>
            </div>
          </MetaSection>
        </GridCol>

        <GridCol :size="12" class="mb-4">
            <cards title="Form Realisasi KPI" :withmin="false">
              <div class="row">
                <div class="col d-flex flex-column">
                  <span class="text-secondary text-xs">Periode Penilaian</span>
                  <span>{{ data?.periode_penilaian || '-' }}</span>
                </div>
                <div class="col d-flex flex-column">
                  <span class="text-secondary text-xs">Cabang Induk</span>
                  <span>{{ data?.cabang || '-' }}</span>
                </div>
                <div class="col d-flex flex-column">
                  <span class="text-secondary text-xs">Kode Cabang Induk</span>
                  <span>{{ data?.kode_cabang || '-' }}</span>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col d-flex flex-column">
                  <span class="text-secondary text-xs">Status</span>
                  <span>{{ data?.status ? (data.status === 'active' ? 'Aktif' : 'Non Aktif') : '-' }}</span>
                </div>
              </div>
            </cards>
        </GridCol>

        <GridCol :size="12">
          <cards title="Target Konsolidasi" :withmin="false">
            <div class="mb-4 d-flex items-center justify-content-between">
              <h5>Target Konsolidasi</h5>
              <!-- <ThreeDotsMenu>
                <button type="button" @click.prevent
                  class="text-secondary font-weight-bold text-xs btn btn-link" role="link"
                  data-toggle="tooltip" data-original-title="Delete">Hapus</button>
              </ThreeDotsMenu> -->
            </div>

            <!-- <pre>{{ list_penilaian_kinerja }}</pre> -->
            <form-group
              v-for="(item,index) in data?.list_kpi"
              :key="index"
            >
              <!-- :label="item?.kpi || 'Dana Pihak Ketiga'"
              :hint="item?.sub_jumlah || item?.sub_jumlah === 0 ? item?.sub_jumlah : (sumBobotSubKpi(item?.sub_kpi || []))" -->

              <div class="d-flex items-center justify-content-between">
                <h6>{{ item?.kpi || '-' }}{{ item?.jabatan ? ' - '+ item?.jabatan : '' }}</h6>
                <!-- <ThreeDotsMenu>
                  <button type="button" @click.prevent
                    class="text-secondary font-weight-bold text-xs btn btn-link" role="link"
                    data-toggle="tooltip" data-original-title="Delete">Hapus</button>
                </ThreeDotsMenu> -->
              </div>

              <div class="table-responsive">
                <table class="table align-middle border border-1 border-light">
                  <thead class="table-light">
                    <tr>
                      <th>Sub KPI</th>
                      <th>Satuan</th>
                      <th>Target</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item_sub, i) in item?.sub_kpi"
                      :key="i"
                      class="border border-bottom-1 border-light rounded-3"
                    >
                      <td>
                        <p>{{ item_sub?.title || '-' }}</p>
                      </td>
                      <td width="150">
                        <p class="text-capitalize">{{ item_sub?.satuan_konsolidasi || '-' }}</p>
                      </td>
                      <td width="100">
                        <p>
                          <span v-if="item_sub?.satuan_konsolidasi?.toLowerCase() === 'rupiah'">
                            {{
                              new Intl.NumberFormat('id-ID', {
                                style: 'currency',
                                currency: 'IDR',
                                minimumFractionDigits: 0,
                              }).format(item_sub?.target_konsolidasi || '0')
                            }}
                          </span>
                          <span v-else>
                            {{
                              new Intl.NumberFormat('id-ID', {
                                minimumFractionDigits: 0,
                              }).format(item_sub?.target_konsolidasi || '0')
                            }} 
                            <span class="text-capitalize">{{ (item_sub?.satuan_konsolidasi?.toLowerCase() === 'persen' ? '%' : item_sub?.satuan_konsolidasi) || '' }}</span>
                          </span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </form-group>
          </cards>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
// import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue"
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import MetaSection from "@/components/MetaSection.vue";
// import InputForm from '@/components/InputForm.vue';
// import ListView from '@/components/ListView.vue';
// import ThreeDotsMenu from "@/components/ThreeDotsMenu.vue";
// import SelectForm from '@/components/SelectForm.vue';

// import KpiApi from "@/repository/api/KpiApi";
// import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
// import JabatanApi from "@/repository/api/JabatanApi";
// import AspekKinerjaApi from "@/repository/api/AspekKinerjaApi";
import TargetKonsolidasiApi from '@/repository/api/TargetKonsolidasiApi';

export default {
  // name: "profile",
  components: {
    // FieldsetComponent,
    Cards,
    FormGroup,
    ArgonButton,
    GridRow,
    GridCol,
    MetaSection,
    // InputForm,
    // ListView,
    // ThreeDotsMenu,
    // SelectForm,
  },
  data() {
    return {
      data: null,
    };
  },
  
  methods: {
    async getData() {
      this.$store.state.loading = true;
      await TargetKonsolidasiApi.getDetail(this.$route.params.id)
        .then((response) => {
          // console.log(response?.data)
          this.data = response?.data || null;
          // const data = response?.data;

          // if (data) {
          //   // this.data.title = data?.title || '';
          //   this.data.periode_id = data?.periode || '';
          //   this.data.cabang_id = data?.unitkerja || '';
          //   this.data.status = data?.status || '';
  
          //   this.list_aspek_selected = data?.list_kpi?.map((item) => {
          //     item.title = item?.kpi;

          //     item.child = item?.sub_kpi?.map(item_child => {
          //       item_child.satuan = item_child.satuan_konsolidasi;
          //       item_child.target = item_child.target_konsolidasi;

          //       return item_child;
          //     });

          //     delete item.list_kpi;

          //     return item;
          //   })
          // }
        })
        .catch((error) => {
          console.log(error)
          this.$swal({
            icon: "error",
            title: error?.response?.data?.message || 'Something wrong, please try again.',
          });
        })
      this.$store.state.loading = false;
    },
  },
  async mounted() {
    if (this.$route.params.id) {
      await this.getData();
    }
  },
};
</script>
